<template>
  <div class="menu">
    <div class="logo-box">
      <img src="../assets/logo.png" class="logo" />
      <div class="btn" @click="selectMenu(5)">Hubungi kami</div>
    </div>

    <div class="menu-box">
      <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">Perkenalan</div>
      <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">
        Sejarah Perkembangan
      </div>

      <!-- <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">核心業務</div> -->
      <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">
        Perekrutan Sukarelawan
      </div>
      <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">Target</div>
      <div :class="step == 5 ? 'select' : ''" @click="selectMenu(5)">
        Hubungi Kami
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "business" });
          break;
        case 3:
          this.$router.push({ path: "privacy" });
          break;
        case 4:
          this.$router.push({ path: "offers" });
          break;
        case 5:
          this.$router.push({ path: "aboutUs" });
          break;
        // case 5: this.$router.push({ path: "cooperate" }); break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.menu {
  .logo-box {
    height: 110px;
    background: #f2f2f2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 360px;
    .logo {
      width: 354px;
      height: 36px;
    }
    .btn {
      width: 136px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      background: #ce3723;
      border-radius: 30px;
    }
  }

  .menu-box {
    display: flex;
    padding: 16px 360px;
    width: 700px;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-family: Inter, Inter;
    font-weight: 500;
    color: #1e1e1e;
    cursor: pointer;
  }

  .select {
    color: #ce3723;
    background-color: #fff;
    border-bottom: 3px solid #ce3723;
  }
}
</style>
